module.exports = __webpack_public_path__ + "img/box.fce6bf0f.svg";